// TODO: merge with LiveAssessment WelcomeForm and remove the duplicate code
import React from 'react';

import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
} from 'reactstrap';
import { Icon } from 'js/components';

import { faSignIn } from '@fortawesome/pro-regular-svg-icons';
import Logo from 'images/logo-dark.svg';
import { useAssessmentContext } from '../../../AssessmentContext';

import styles from './WelcomeForm.module.scss';

export function WelcomeFormSSO({
  participant,
  assessment,
}) {  
  const { supplemental = {} } = useAssessmentContext();

  return (
    <div className={styles['welcome-form']}>
      <Card>
        <CardHeader>
          <CardTitle>
            <center>
              <div>Welcome to a</div>
              <h5>Capabilities Assessment</h5>
              <div className="subtitle">
                for {supplemental?.user_group_name ?? 'your user group'}
              </div>
            </center>
          </CardTitle>
        </CardHeader>
        <CardBody>
          {/* <div className={styles.gem}>
            <Icon icon={gemIcon} />
          </div> */}
          <p>
            This assessment is restricted. Please sign in through your corporate
            account to participate.
          </p>
          <form method="post" action={`/saml/assessments/${assessment.id}/sso`}>
            <input type="hidden" name="token" value={participant.token} />
            <div className={styles.actions}>
              <Button
                color="primary"
                type="submit"
                data-test="join-as-guest-link"
              >
                <Icon icon={faSignIn} fixedWidth className="btn-icon-left" />
                Take me to login
              </Button>
            </div>
          </form>
          <div className={styles.logo}>
            <img src={Logo} alt="Waypointr" height={20} />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default WelcomeFormSSO;
